import React, { useState } from "react";
import config from "../../../../config";
import Confirm from "../../../molecules/Confirm";
import { trackPromise } from "react-promise-tracker";
import { apiDeleteFile, apiPostFiles } from "../../../../utils/queries";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./FilesForm.css";

export const FilesForm = (props) => {
  const [toggleConfirmFileDelete, setToggleConfirmFileDelete] = useState(false);
  const [selectedFile, setSelectedFile] = useState({});

  const addAlert = props.addAlert;

  const onDeleteFile = (file) => {
    setSelectedFile(file);
    setToggleConfirmFileDelete(true);
  };

  const ALLOWED_TYPES = ["application/pdf", "image/jpeg", "image/png"];

  const selectedFilesChanged = async (e) => {
    const form = new FormData();
    form.append("BankDataId", props.bankDataId);
    form.append("RequestId", props.accountId);
    form.append("Token", props.token);

    for (let index = 0; index < e.target.files.length; index++) {
      const file = e.target.files[index];

      if (!ALLOWED_TYPES.includes(file.type)) {
        addAlert(`"${file.name}" is not an allowed file type. Only PDF, JPG, JPEG and PNG are accepted.`, "error");
        e.target.value = "";
        return;
      }
      if (file.size > config.MAX_ATTACHMENT_SIZE) {
        addAlert(`"${file.name}" exceeds the 5 MB size limit.`, "error");
        e.target.value = "";
        return;
      }
      if (props.fileList.some((f) => f.displayName === file.name)) {
        addAlert(`"${file.name}" has already been added.`, "error");
        e.target.value = "";
        return;
      }
      form.append("file", file);
    }

    // Reset the input so the same file can be re-selected after removal
    e.target.value = "";

    try {
      const result = await trackPromise(apiPostFiles(form));
      props.setFileList([...props.fileList, ...result.data]);
      addAlert("File uploaded successfully.", "success");
    } catch (error) {
      addAlert(`Upload failed. Please contact Hafnia.`, "error");
    }
  };

  const onDeleteFileConfirmed = async () => {
    try {
      await trackPromise(apiDeleteFile(props.token, selectedFile.fileName));
      props.setFileList(
        props.fileList.filter((f) => f.fileName !== selectedFile.fileName)
      );
      addAlert("File deleted.", "success");
    } catch (error) {
      addAlert("Could not delete file. Please contact Hafnia.", "error");
    }
  };

  const visibleFiles = props.fileList?.filter(
    (file) => file.bankDataId === props.bankDataId
  );

  return (
    <>
      {visibleFiles?.length > 0 && (
        <div className="hp-file-list">
          {visibleFiles.map((file, index) => (
            <div key={index} className="hp-file-item">
              <div className="hp-file-item__icon">
                <FontAwesomeIcon icon={faFileAlt} size="sm" />
              </div>
              <a
                className="hp-file-item__name hp-file-item__name--link"
                href={file.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {file.displayName}
              </a>
              <button
                type="button"
                className="hp-file-item__delete"
                title="Remove file"
                onClick={() => onDeleteFile(file)}
              >
                <FontAwesomeIcon icon={faTrash} size="xs" />
              </button>
            </div>
          ))}
        </div>
      )}

      <label htmlFor={"file-upload-" + props.name} className="hp-file-dropzone">
        <span className="hp-file-dropzone__icon">+</span>
        <span className="hp-file-dropzone__text">Add File</span>
        <span className="hp-file-dropzone__hint">PDF, JPG, JPEG, PNG · max 5 MB</span>
      </label>
      <input
        id={"file-upload-" + props.name}
        type="file"
        accept=".pdf,.jpg,.jpeg,.png"
        onChange={selectedFilesChanged}
        multiple
        style={{ display: "none" }}
      />

      <Confirm
        onConfirm={onDeleteFileConfirmed}
        text="Are you sure you want to delete this file?"
        toggle={toggleConfirmFileDelete}
        setToggle={setToggleConfirmFileDelete}
      />
    </>
  );
};

